.page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px 80px;
}

.header {
  padding: 28px 0 20px;
}

.backBtn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--blue);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  background: none;
  border: none;
  padding: 6px 0;
  margin-bottom: 12px;
  transition: opacity .15s;
  font-family: 'Roboto', sans-serif;
}
.backBtn:hover { opacity: .75; }

.headerTitle {
  font-family: 'Google Sans', sans-serif;
  font-size: 22px;
  font-weight: 600;
  color: var(--ink);
  letter-spacing: -.01em;
  margin-bottom: 4px;
}

.headerSub {
  font-size: 14px;
  color: var(--muted);
}

/* Toolbar */
.toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0 16px;
  border-bottom: 1px solid var(--border);
  margin-bottom: 16px;
}

.selectAll {
  font-size: 13.5px;
  font-weight: 500;
  color: var(--blue);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-family: 'Roboto', sans-serif;
}
.selectAll:hover { opacity: .75; }

.selectedCount {
  font-size: 13.5px;
  color: var(--muted);
  flex: 1;
}

.deleteBtn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 20px;
  background: var(--red);
  color: white;
  border: none;
  border-radius: 24px;
  font-size: 13.5px;
  font-weight: 600;
  font-family: 'Google Sans', sans-serif;
  cursor: pointer;
  transition: background .15s, opacity .15s;
}
.deleteBtn:hover:not(:disabled) { background: #a81b18; }
.deleteBtn:disabled { opacity: .4; cursor: default; }

/* Summary bar after run */
.summary {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 0 16px;
  border-bottom: 1px solid var(--border);
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 500;
}

.summarySuccess {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--green);
}

.summaryError {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--red);
}

/* Channel rows */
.list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 18px;
  background: white;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  cursor: pointer;
  transition: border-color .15s, background .15s;
}

.row:hover { border-color: #c5c8cc; background: #fafafa; }
.rowSelected { border-color: var(--red); background: #fff8f8; }
.rowSuccess { border-color: var(--green); background: var(--green-lt); cursor: default; }
.rowError { border-color: var(--red); background: var(--red-lt); cursor: default; }

.checkbox {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 2px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all .15s;
}

.checkboxChecked {
  background: var(--red);
  border-color: var(--red);
  color: white;
}

.statusIcon { color: var(--muted2); flex-shrink: 0; }
.statusIconSuccess { color: var(--green); flex-shrink: 0; }
.statusIconError { color: var(--red); flex-shrink: 0; }

.rowBody { flex: 1; min-width: 0; }

.rowName {
  font-size: 15px;
  font-weight: 600;
  color: var(--ink);
  font-family: 'Google Sans', sans-serif;
}

.rowMeta {
  margin-top: 3px;
  font-size: 12.5px;
  color: var(--muted2);
}

.rowResult {
  margin-top: 3px;
  font-size: 13px;
  color: var(--green);
  font-weight: 500;
}

.rowResultError {
  margin-top: 3px;
  font-size: 13px;
  color: var(--red);
}
